export enum SectionId {
  Advantages = 'advantages',
  Variety = 'variety',
  Installation = 'installation',
  Savings = 'savings',
  Action = 'action',
  Models = 'models',
  Calculator = 'calculator',
}
